<template>
    <b-navbar class="justify-content-center border-top" type="light" variant="light">
        <b-navbar-brand href="#" class="d-md-down-none">
            <small><i class="text-muted fa-regular fa-address-card"></i></small>
        </b-navbar-brand>
        <b-navbar-nav v-if="hasInsurances" v-for="(insurance, index) in insurances" :class="{'ml-3': index === (insurances.length -1)}" :key="insurance.id">
            <span :class="{'text-danger': !insurance.is_active, 'text-primary': insurance.is_primary && insurance.is_active }">
             <small>{{insurance.name }}</small>
            </span>
        </b-navbar-nav>
        <b-navbar-nav v-else>No insurances.</b-navbar-nav>
    </b-navbar>
</template>
<script>
import FormExtension from "@/core/components/FormExtension"
import { mapActions } from "vuex"

export default FormExtension.extend({
    name: 'schedule-insurances',
    data () {
        return {
            insurances: [],
        }
    },
    computed: {
        hasInsurances() {
            return this.insurances.length > 0
        }
    },
    methods: {
        ...mapActions('insurances', ['getInsurancesForCurrentPatient']),
        async loadForPatient(patient) {
            this.insurances = await this.getInsurancesForCurrentPatient()
        }
    }
})

</script>